import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AuthContainer from './AuthContainer';
import HomePage from './pages/home';
import DocsPage from './pages/DocsPage';
import ToolsPage from './pages/ToolsPage';
import RebatePage from './pages/RebatePage';
import RebateDetailPage from './pages/RebateDetailPage';
import AirdropPage from './pages/AirdropPage';
import SocialPage from './pages/SocialPage';
import MarketHeatmapPage from './pages/MarketHeatmapPage';
import Jin10NewsPage from './pages/Jin10NewsPage';
import GoldCalculatorPage from './pages/GoldCalculatorPage';
import GoldTrendRadarPage from './pages/GoldTrendRadarPage';
import MarketRadarPage from './pages/MarketRadarPage';
import PatternMatchPage from './features/patternMatch/PatternMatchPage';
import DumpDetectivePage from './features/dumpDetective/DumpDetectivePage';
import DumpDetectiveReportPage from './features/dumpDetective/DumpDetectiveReportPage';
import SupportResistancePage from './features/supportResistance/SupportResistancePage';
import UserProfile from './components/UserProfile';
import CryptoDetailPage from './pages/CryptoDetailPage';
import InstitutionDetailPage from './pages/InstitutionDetailPage';
import InstitutionListPage from './pages/InstitutionListPage';
import StockFundamentalsPage from './pages/StockFundamentalsPage';
import StockDetailPage from './pages/StockDetailPage';
import BooksPage from './pages/books/BooksPage';
import BookDetailPage from './pages/books/BookDetailPage';
import LangToggle from './components/LangToggle';
import GlobalNav from './components/GlobalNav';
import GlobalFooter from './components/GlobalFooter';
import { LanguageProvider } from './i18n/context';
import useUserStore from './store/userStore';

function ProtectedRoute({ isLoggedIn, children }) {
  return isLoggedIn ? children : <Navigate to="/login" />;
}

function AppInner() {
  const { isLoggedIn, token } = useUserStore();
  const location = useLocation();
  const hideNav = location.pathname.startsWith('/login') || location.pathname.startsWith('/register') || location.pathname.startsWith('/forgot');

  // 页面刷新时校验 token 恢复登录
  useEffect(() => {
    if (token) {
      const store = useUserStore.getState();
      store.verifySession();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!hideNav && <GlobalNav />}
      {!hideNav && <LangToggle />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tools" element={<ToolsPage />} />
        <Route path="/market-heatmap" element={<MarketHeatmapPage />} />
        <Route path="/jin10-news" element={<Jin10NewsPage />} />
        <Route path="/gold-calculator" element={<GoldCalculatorPage />} />
        <Route path="/gold-trend" element={<GoldTrendRadarPage />} />
        <Route path="/market" element={<MarketRadarPage />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/docs/:docId" element={<DocsPage />} />
        <Route path="/airdrop" element={<AirdropPage />} />
        <Route path="/social" element={<SocialPage />} />
        <Route path="/social/:username" element={<SocialPage />} />
        <Route path="/rebate" element={<RebatePage />} />
        <Route path="/rebate/:exchange" element={<RebateDetailPage />} />
        <Route path="/pattern-match" element={<PatternMatchPage />} />
        <Route path="/dump-detective" element={<DumpDetectivePage />} />
        <Route path="/dump-detective/report/:chain/:address" element={<DumpDetectiveReportPage />} />
        <Route path="/support-resistance" element={<SupportResistancePage />} />
        <Route path="/profile" element={<ProtectedRoute isLoggedIn={isLoggedIn}><UserProfile /></ProtectedRoute>} />
        <Route path="/crypto/:symbol" element={<CryptoDetailPage />} />
        <Route path="/institution/:cik" element={<InstitutionDetailPage />} />
        <Route path="/institutions" element={<InstitutionListPage />} />
        <Route path="/fundamentals" element={<StockFundamentalsPage />} />
        <Route path="/stock/:ticker" element={<StockDetailPage />} />
        <Route path="/books" element={<BooksPage />} />
        <Route path="/book/:bookId" element={<BookDetailPage />} />
        <Route path="/login" element={isLoggedIn ? <Navigate to="/" /> : <AuthContainer page="login" />} />
        <Route path="/register" element={isLoggedIn ? <Navigate to="/" /> : <AuthContainer page="register" />} />
        <Route path="/forgot" element={isLoggedIn ? <Navigate to="/" /> : <AuthContainer page="forgot" />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      {!hideNav && <GlobalFooter />}
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppInner />
    </LanguageProvider>
  );
}

export default App;
